import React from "react";
import { Box, Typography, Button, Modal } from "@mui/material";
import { useTheme } from "@mui/material";

const ProductVariantsModal = ({
  open,
  onClose,
  onSaveAsSingleProduct,
  onAddVariants,
}) => {
  const theme = useTheme();

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(3px)",
      }}
    >
      <Box
        sx={{
          width: '293px',
          height: '286px',
          backgroundColor: 'white',
          borderRadius: '8px',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ textAlign: 'center', width: '100%' }}>
          <Typography
            sx={{
              fontFamily: 'Lexend',
              fontSize: '20px',
              fontWeight: 600,
              color: theme.palette?.primary?.main || '#0F0F0F',
              mb: 2,
            }}
          >
            Product Variants?
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Lexend',
              fontSize: '14px',
              fontWeight: 400,
              color: theme.palette?.primary?.main || '#0F0F0F',
              mb: 1,
            }}
          >
            Would you like to add variants for this product?
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Lexend',
              fontSize: '12px',
              fontWeight: 400,
              color: theme.palette?.text?.secondary || '#656565',
            }}
          >
            (For example: color, size, material, or pattern differences.)
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
          <Button
            onClick={onSaveAsSingleProduct}
            variant="outlined"
            sx={{
              borderColor: theme.palette?.primary?.main || '#0F0F0F',
              color: theme.palette?.primary?.main || '#0F0F0F',
              fontFamily: 'Lexend',
              fontSize: '14px',
              fontWeight: 400,
              textTransform: 'none',
              py: 1.5,
              borderRadius: '4px',
              '&:hover': {
                borderColor: theme.palette?.primary?.dark || '#000000',
                backgroundColor: 'transparent',
              },
            }}
          >
            No, save as single product
          </Button>
          <Button
            onClick={onAddVariants}
            variant="contained"
            sx={{
              backgroundColor: theme.palette?.primary?.main || '#0F0F0F',
              color: '#FFFFFF',
              fontFamily: 'Lexend',
              fontSize: '14px',
              fontWeight: 400,
              textTransform: 'none',
              py: 1.5,
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: theme.palette?.primary?.dark || '#000000',
              },
            }}
          >
            Yes, add variants
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ProductVariantsModal;

